import { render, staticRenderFns } from "./TranslationUploadBatchList.vue?vue&type=template&id=cd15dc4e"
import script from "./TranslationUploadBatchList.vue?vue&type=script&lang=js"
export * from "./TranslationUploadBatchList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports